
export function CoursesStatusUpdater() {
    processCourses();
}


function isCourseIdSaved(courseId) {
    const savedCourses = localStorage.getItem('courses');
    const courseIds = savedCourses ? JSON.parse(savedCourses) : [];
    return courseIds.includes(courseId);
}

// Function to update the 'icon_color__green' class based on the course saved status
function updateCourseSavedStatusClass(container) {
    const saveButtonElement = container.querySelector('#toggle-save-course');
    const svgElements = saveButtonElement.querySelectorAll('svg');

    if (isCourseIdSaved(container.dataset.courseId)) {
        svgElements.forEach(function (svg) {
            svg.classList.add('icon_color__green');
        });
    } else {
        svgElements.forEach(function (svg) {
            svg.classList.remove('icon_color__green');
        });
    }
}

function countSavedCourseIds() {
    const courses = localStorage.getItem('courses');
    return courses ? JSON.parse(courses).length : 0;
}

function updateCoursesCountDisplay() {
    const count = countSavedCourseIds();
    const displayElements = document.querySelectorAll('#saved-courses-count');

    displayElements.forEach(function (element) {
        element.textContent = count;
    });
}

function attachEventListeners(container) {
    const saveButton = container.querySelector('#toggle-save-course');

    // Check if the event listener has already been attached using a data attribute
    if (saveButton && !saveButton.hasAttribute('data-listener-attached')) {
        
        saveButton.addEventListener('click', function (event) {
            event.preventDefault();

            // Toggle the saved status of the course
            if (isCourseIdSaved(container.dataset.courseId)) {
                removeCourseId(container.dataset.courseId);
            } else {
                saveCourseId(container.dataset.courseId);
            }

            // Update UI based on the current saved status
            updateCourseSavedStatusClass(container);

            //Todo: Add this, maybe move it as an exported function.
            updateCoursesCountDisplay();

        });

        // Mark the button as having an event listener attached
        saveButton.setAttribute('data-listener-attached', 'true');
    }
}


function saveCourseId(courseId) {
    let courses = localStorage.getItem('courses');
    if (courses) {
        courses = JSON.parse(courses);
        if (!courses.includes(courseId)) {
            courses.push(courseId);
        }
    } else {
        courses = [courseId];
    }

    localStorage.setItem('courses', JSON.stringify(courses));

    updateCoursesCountDisplay();
}

function removeCourseId(courseId) {
    let courses = localStorage.getItem('courses');
    if (courses) {
        courses = JSON.parse(courses);
        courses = courses.filter(id => id !== courseId);
        localStorage.setItem('courses', JSON.stringify(courses));
    }

    updateCoursesCountDisplay();
}

function processCourses() {
    // Get all <article> elements with 'data-controller="SavedCoursesController"'
    const articles = document.querySelectorAll('article[data-controller="SavedCoursesController"]');

    // Loop through each article and update its SVG class based on the saved status
    articles.forEach(article => {
        updateCourseSavedStatusClass(article);
        attachEventListeners(article);
    });
}